module.exports = __webpack_public_path__ + "static/img/serve3.5175ca8c.png";